var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIncoming(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 10,
    fill: "#ECFDF3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7456 7.40156L8.74429 12.3395L12.4401 12.3673C12.6388 12.3846 12.8216 12.4787 12.9518 12.631C13.082 12.7832 13.1502 12.9824 13.1426 13.1886C13.135 13.3948 13.0522 13.5929 12.9109 13.7434C12.7695 13.8938 12.5799 13.9854 12.38 14L6.76739 13.9621C6.71453 13.962 6.66203 13.9558 6.61087 13.9437C6.58819 13.9395 6.56589 13.9335 6.54416 13.9259L6.46103 13.8963L6.38956 13.8553C6.37263 13.8405 6.35725 13.8239 6.34367 13.8058C6.25924 13.7455 6.18769 13.6683 6.13308 13.5785C6.11615 13.5637 6.10077 13.5471 6.08719 13.529L6.05067 13.4535C6.03177 13.4331 6.03596 13.3954 6.0258 13.3664C6.01938 13.3437 6.0146 13.3204 6.01152 13.2968C6.00204 13.2435 5.99839 13.1891 6.00065 13.1346L6.21371 7.34493C6.2367 7.13942 6.33383 6.948 6.4857 6.8089C6.63756 6.66981 6.83298 6.59329 7.0329 6.59464C7.23281 6.59599 7.4225 6.67511 7.56406 6.81618C7.70562 6.95726 7.78861 7.1499 7.79647 7.35561L7.66437 11.174L12.6657 6.23604C12.8202 6.0835 13.0253 5.9986 13.2358 6.00002C13.4463 6.00144 13.645 6.08907 13.7883 6.24362C13.9315 6.39818 14.0074 6.607 13.9994 6.82416C13.9914 7.04131 13.9001 7.24901 13.7456 7.40156Z",
    fill: "#079455"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncoming);
export default __webpack_public_path__ + "static/media/incoming.6b16087a492705dbedc2c07176566923.svg";
export { ForwardRef as ReactComponent };